// file for handling the top filters.
//Import Libraries
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { config } from "../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import InputLabel from "@mui/material/InputLabel";
import Loader from "../../../components/Loader/Loader";
import FileUpload from "../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../components/FileUpload/GlobalDropZone";
import { useUserAuthentication } from "../../../utils/utils";
import Popover from "@mui/material/Popover";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    updateSourceInputs,
    loading,
    setMappedData,
    updateAlert,
    isPlaceholderFetching,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isCountryLoading, setIsCountryLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  let history = useHistory();
  const URL = history?.location?.pathname;
  // const Use_Case_Name = URL.split("/").pop();
  const Use_Case_Name = source_data?.current_usecase_value || "product_mapping";

  const open = Boolean(anchorEl);
  const { login } = useUserAuthentication();

  const has_Awaiting_Data = useMemo(() => {
    const data = source_data?.has_awaiting_data;

    if (!data) return false;

    const { has_records, has_access } = data;

    return !has_records || (has_records && has_access);
  }, [source_data.has_awaiting_data]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  // FETCH META DATA FOR SELECTED DATASET
  const handleSourceChange = async (e, selectedOption) => {
    setIsCountryLoading(true);
    updateSourceInputs("current_source", selectedOption.value);
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_usecase", "");
    updateSourceInputs("isNewLocalValue_logs", []);
    updateSourceInputs("isNewMappedValue_logs", []);
    updateSourceInputs("isNewDropdownLocalValue", false);
    updateSourceInputs("isNewDropdownMappedValue", false);

    const DROPDOWN_DATAS = source_data?.data?.dropdown || [];
    const SORTED_EDIT_MODAL_COLUMN_LIST =
      source_data?.temp_edit_modal_column_list?.filter(
        (item) =>
          !DROPDOWN_DATAS?.ignore_table_columns?.[
            selectedOption.value
          ]?.includes(item?.name || ""),
      );
    const SORTED_TABLE_HEADER_COLUMN_LIST =
      source_data?.temp_table_header_column_list?.filter(
        (item) =>
          !DROPDOWN_DATAS?.ignore_table_columns?.[
            selectedOption.value
          ]?.includes(item?.name || ""),
      );

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        source: selectedOption?.value || "",
      });

      const response = await fetch(
        api + `/product_mapping/getcountries?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return false;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const COUNTRIES = data?.data || [];
      const FINAL_COUNTRIES =
        COUNTRIES?.map((item) => {
          return { label: item, value: item };
        }) ?? [];
      const FINAL_DROPDOWN_DATA = {
        ...source_data?.data,
        dropdown: {
          ...DROPDOWN_DATAS,
          edit_model_column_list: SORTED_EDIT_MODAL_COLUMN_LIST || [],
          table_header_column_list: SORTED_TABLE_HEADER_COLUMN_LIST || [],
        },
      };
      updateSourceInputs("current_mapped_country", FINAL_COUNTRIES);
      updateSourceInputs("data", FINAL_DROPDOWN_DATA);
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsCountryLoading(false);
  };

  // FETCH COUNTRIES FOR SELECTED SOURCE
  const handleCountryChange = async (e, selectedOption) => {
    setIsFilterLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("current_country_code", selectedOption.value);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_usecase", "");
    updateSourceInputs("current_usecase_list", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isAnyRecordDeleted", false);
    updateSourceInputs("isNewLocalValue_logs", []);
    updateSourceInputs("isNewMappedValue_logs", []);
    updateSourceInputs("isNewDropdownLocalValue", false);
    updateSourceInputs("isNewDropdownMappedValue", false);

    // const COUNTRIES_LIST = source_data?.data?.dropdown?.COUNTRY || [];
    // const MATCHING_COUNTRY =
    //   COUNTRIES_LIST?.find(
    //     (item) => item.country_code === selectedOption.value
    //   ) ?? {};
    // updateSourceInputs("current_country", MATCHING_COUNTRY?.COUNTRY || "");

    const params = new URLSearchParams({
      usecase_name: Use_Case_Name || "",
      source: source_data?.current_source || "",
      country_code: selectedOption.value || "",
    });

    try {
      const response = await fetch(
        api + `/product_mapping/getusecase?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const Usecases = data.data || [];

      const FINAL_USECASES =
        Usecases?.map((item) => {
          return { label: item, value: item };
        }) ?? [];

      updateSourceInputs("current_usecase_list", FINAL_USECASES);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsFilterLoading(false);
  };

  // FETCH TABLE DATA FOR SELECTED MAPPING TYPE
  const handleUsecaseChange = async (e, selectedOption) => {
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("current_usecase", selectedOption);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isAnyRecordDeleted", false);
    updateSourceInputs("isNewLocalValue_logs", []);
    updateSourceInputs("isNewMappedValue_logs", []);
    updateSourceInputs("isNewDropdownLocalValue", false);
    updateSourceInputs("isNewDropdownMappedValue", false);

    // API call to fetch Table Data
    setMappedData(
      source_data?.current_source || "",
      source_data?.current_country_code || "",
      selectedOption?.value || "",
    );
  };

  // GET PLACEHOLDER DATA FOR SELECTED SFF_FILE_ID - ONLY FOR CREATE NEW FILTER
  const handlePlaceholderFile = async () => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", // 5 equal-width columns
              gridTemplateRows: "1fr", // 1 row
              gap: "12px", // gap between columns (and rows if any)
              padding: "2px 15px 0px 15px",
              width: "100%",
            }}
          >
            <>
              {/* DATASETS */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Source:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data.current_mapped_source}
                    loading={
                      loading &&
                      (source_data.current_mapped_source ||
                        source_data.current_mapped_source.length === 0)
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSourceChange}
                    value={
                      source_data.current_source &&
                      source_data.current_source.length > 0
                        ? {
                            label: source_data.current_source,
                            value: source_data.current_source,
                          }
                        : null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_source === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        fontSize: "13px",
                        height: "36px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* COUNTRY CODE  */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Country code:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    loading={isCountryLoading}
                    disabled={
                      !source_data.current_source ||
                      source_data.current_source.length === 0
                    }
                    options={source_data?.current_mapped_country || []}
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleCountryChange}
                    value={
                      {
                        label: source_data.current_country_code,
                        value: source_data.current_country_code,
                      } || null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_source === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_source === ""
                            ? "#d6d6d6"
                            : "#fff",
                        borderRadius: "6px",
                        fontSize: "13px",
                        height: "36px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* MAPPING TYPE */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Mapping Type:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    disabled={
                      !source_data.current_country_code ||
                      source_data.current_country_code.length === 0
                    }
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data?.current_usecase_list || []}
                    loading={isFilterLoading}
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleUsecaseChange}
                    value={source_data?.current_usecase || null}
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_country_code === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_country_code === ""
                            ? "#d6d6d6"
                            : "#fff",
                        borderRadius: "6px",
                        fontSize: "13px",
                        height: "36px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      )}

      {isPlaceholderFetching && <Loader />}

      {/* FILE UPLOAD OR PLACEHOLDER SELECTION */}
      {!expand &&
        !isPlaceholderFetching &&
        !props.isFileUploading &&
        source_data.is_initial &&
        source_data.is_table_loading &&
        has_Awaiting_Data && (
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            {source_data.current_country_code !== "" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "15px" }}
              >
                <div>
                  <GlobalDropZone
                    updateAlert={updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    requiredColumns={
                      source_data?.data?.dropdown?.insert_column_attributes ||
                      []
                    }
                  />
                  <FileUpload
                    updateAlert={updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    isFileUploading={props.isFileUploading}
                    requiredColumns={
                      source_data?.data?.dropdown?.download_sample_columns || []
                    }
                    source_Data={source_data}
                    updateSourceInputs={updateSourceInputs}
                    user={user}
                  />
                </div>
                <span>Or</span>
                <button
                  onClick={handlePlaceholderFile}
                  className="sample-button"
                  // disabled={source_data.is_table_loading}
                >
                  Proceed with Existing Mappings
                </button>
              </div>
            )}
          </div>
        )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  cncData: PropTypes.object,
  brand_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter),
);
